import React from 'react'
import { connect } from 'react-redux'
import { fetchGoodsDetail } from '@/api/shopping-car'
import { addGood as addGoodApi } from '@/api/store'
import { Toast } from 'antd-mobile'
import { Link } from 'react-router-dom'
import './goods-detail.less'
import { setHeader } from '@/util/set-header'
import { History } from 'history'
import { goodStorage } from '@/util/good-storage'
import {
  fetchGoodsCount as fetchGoodsCountApi,
} from '@/api/store'
import { setGoodTotal } from '@/util/good-total.dispath'


interface Props {
  depot_id: string
  match: any
  history: History
  goodsTotal: string | number
  // setGoodsCountAction: (count: string | number) => any
}
interface State {
  info: any
  url: string
  isLoading: boolean
}
const mapStateToProps = (state: any) => {
  return {
    depot_id: state.depot.id,
    goodsTotal: state.goods.count,
  }
}

// const mapDispatchToProps = (dispatch: any) => ({
//   setGoodsCountAction: (count: string | number) =>
//     dispatch({ type: GOODS_SET_COUNT, count }),
// })

const GoodCarts = ({ goodsCount }: any) => (
  <div className="good-carts">
    <img src="/public/assets/img/shopping_cart_icon.png" alt="" />
    {parseInt(goodsCount) > 0 && (
      <span className="badge-count font-9">{goodsCount}</span>
    )}
  </div>
)
@(connect(mapStateToProps) as any)
class GoodsDetail extends React.Component<Props, State> {
  goodsTotalLock = false
  constructor(props: any) {
    super(props)
    this.state = {
      info: {},
      url: '',
      isLoading: false
    }
    this.leftClick = this.leftClick.bind(this)
  }
  leftClick() {
    const { history } = this.props
    if(history.length>1){
      history.goBack()
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('');
      }
    }
  }
  UNSAFE_componentWillMount() {
    if (window.WebViewBridge) {
      window.WebViewBridge?.shouldShowTabBar?.call(window.WebViewBridge, false)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(false);
    }
    setHeader({ title: '商品详情', leftClick: this.leftClick })
  }

  //获取商品详情
  fetchDetail = async (depot_id: string, goodsId: string) => {
    this.setState({ isLoading: true })
    const { data } = await fetchGoodsDetail(depot_id, goodsId)
    if (data.code === 'SUCCESS') {
      const info = data.data

      this.setState({
        info: info,
        url: info.covers[0].url,
        isLoading: false
      })
    } else {
      Toast.info(data.msg, 3)
    }
  }

  componentDidMount = async () => {
    let { depot_id, match, goodsTotal } = this.props
    if (depot_id) {
      this.fetchDetail(depot_id, match.params.id)
      // eslint-disable-next-line
      if (goodsTotal == 0 && !this.goodsTotalLock) {
        const { data } = await fetchGoodsCountApi(depot_id)
        if (data.code === 'SUCCESS') {
          setGoodTotal(data.data)
        }
      }
    }
  }
  componentWillReceiveProps = async (nextProps: Props) => {
    const goodsTotal = nextProps.goodsTotal

    const nextDepotId = nextProps.depot_id
    let { depot_id, match } = this.props
    if (depot_id !== nextDepotId) {
      this.fetchDetail(nextDepotId, match.params.id)
      // eslint-disable-next-line
      if (goodsTotal == 0 && !this.goodsTotalLock) {
        // const { setGoodsCountAction } = this.props
        const { data } = await fetchGoodsCountApi(depot_id)
        if (data.code === 'SUCCESS') {
          setGoodTotal(data.data)
        }
      }
    }
  }

  //添加购物车
  increaseGood = async () => {
    let { depot_id, match } = this.props
    const goodId = match.params.id
    Toast.loading('加载中', 0)
    const { data } = await addGoodApi({ depot_id, id: goodId })
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1.5)
      return
    } else {
      Toast.info('添加成功', 1.5)
    }
    goodStorage.increment(goodId)
  }

  render() {

    const { goodsTotal } = this.props
    const { info, isLoading } = this.state
    let navEle
    if (info.is_rest) {
      navEle = <div className="but store-reast">休息中</div>
    } else if (info.stock === '0' || info.stock === 0) {
      navEle = <div className="but store-reast">商品已售馨</div>
    } else {
      navEle = (
        <div
          className="but"
          onClick={() => {
            this.increaseGood()
          }}
        >
          放入购物袋
        </div>
      )
    }
    return (
      <div className="goods-det">
        {
          isLoading
            ? <div className="skeleton">
              <div className="covers">
              </div>
              <div className="info-text">
                <div className="loading mr-5" style={{ width: '35vw' }}>&nbsp;&nbsp;&nbsp;</div>
                <div className="loading mr-5" style={{ width: '20vw' }}>&nbsp;&nbsp;&nbsp;</div>
                <div className="loading mr-5" style={{ width: '50vw' }}>&nbsp;&nbsp;&nbsp;</div>
                <div className="loading mr-5" style={{ width: '50vw' }}>&nbsp;&nbsp;&nbsp;</div>
              </div>
              <div className="goods-detail-title font-8 loading">
              </div>
            </div>
            : <div className="detail">
              <div className="covers">
                <img src={this.state.url} alt="" />
              </div>
              <div className="info-text">
                <div className="text-ell font-6">{info.title}</div>
                <div className="brief"> {info.brief}</div>
                <div className="text-ell retail font-8">
                  零售价： {info.original_price}
                </div>
                <div className="member-price font-7">
                  <div className="text-ell  font-7 font_yellow">
                    会员价：{info.current_price}
                  </div>
                  <span>已售 {info.sold_count} 件</span>
                </div>
              </div>

              <div className="goods-detail-title font-8">
                <div className="link-top" /> <i className="iconfont ">&#xe600;</i>
                商品详情<i className="iconfont ">&#xe600;</i>
                <div className="link-top" />
              </div>
            </div>
        }

        <div className="flex-lvc nav-car">
          <Link to="/shoppingcar">
            <GoodCarts goodsCount={goodsTotal} />
          </Link>
          {navEle}
        </div>
      </div>
    )
  }
}

export default GoodsDetail
